// Datenschutz.js
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    Button,
    Link as MLink,
    Divider,
} from "@mui/material";
import Footer from "../components/Footer";

// Branding colors (keep in sync with MainApp)
const BRAND_BLUE = "#0d396e";
const BRAND_GREEN = "#00C853";

const Datenschutz = () => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            {/* HERO (same visual language as main page) */}
            <Box sx={{ bgcolor: "#fff", pt: { xs: 6, md: 10 } }}>
                <Container maxWidth="lg">
                    <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
                        <MLink component={RouterLink} to="/" underline="none">
                            <Box
                                component="img"
                                src={`${process.env.PUBLIC_URL}/images/helloqr.png`}
                                alt="HelloQR"
                                sx={{
                                    width: 220,
                                    height: "auto",
                                    borderRadius: 2,
                                    display: "inline-block",
                                    mb: 4,
                                }}
                            />
                        </MLink>
                        <Typography
                            variant="h2"
                            component="h1"
                            sx={{ fontWeight: 800, color: BRAND_BLUE, lineHeight: 1.2 }}
                        >
                            Datenschutzerklärung
                        </Typography>
                        <Typography variant="h6" sx={{ color: "text.secondary", mt: 1 }}>
                            Informationen zur Verarbeitung Ihrer Daten bei Nutzung von HelloQR
                        </Typography>
                    </Box>
                </Container>
            </Box>

            {/* CONTENT CARD */}
            <Box sx={{ bgcolor: "#f8fafc", py: { xs: 6, md: 10 }, flexGrow: 1 }}>
                <Container maxWidth="md">
                    <Card elevation={1} sx={{ borderRadius: 4 }}>
                        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                            {/* Einleitung */}
                            <Typography sx={{ mb: 3 }}>
                                Wir freuen uns über Ihr Interesse an unserem QR-Code-Service. Der Schutz Ihrer
                                personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir
                                Sie über die Verarbeitung Ihrer Daten im Rahmen der Nutzung unseres Dienstes.
                            </Typography>

                            <Divider sx={{ my: 3 }} />

                            {/* Verantwortlicher */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                1. Verantwortlicher
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Felix Hohlwegler<br />
                                Hebelstr. 13<br />
                                78244 Gottmadingen<br />
                                E-Mail:{" "}
                                <MLink href="mailto:info@felix-hohlwegler.de">
                                    info@felix-hohlwegler.de
                                </MLink>
                            </Typography>

                            {/* Zweck der Verarbeitung */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                2. Zweck der Datenverarbeitung
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Die von Ihnen eingegebenen Daten werden ausschließlich zur einmaligen Erzeugung
                                eines QR-Codes verwendet. Es erfolgt keine Speicherung dieser Daten auf dem Server.
                                Auch der erzeugte QR-Code wird nicht serverseitig gespeichert.
                            </Typography>

                            {/* Cookies */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                3. Keine Verwendung von Cookies
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Unsere Website verwendet keine Cookies.
                            </Typography>

                            {/* Speicherung/Weitergabe */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                4. Keine Speicherung oder Weitergabe
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Es werden keine personenbezogenen Daten gespeichert, weitergegeben oder für andere
                                Zwecke verarbeitet. Die Verarbeitung erfolgt flüchtig im Arbeitsspeicher und endet
                                mit der Auslieferung des QR-Codes an Sie.
                            </Typography>

                            {/* Serverstandort */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                5. Serverstandort
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Unsere Server befinden sich in Deutschland. Die Verarbeitung unterliegt damit den
                                Anforderungen der DSGVO.
                            </Typography>

                            {/* Rechte */}
                            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND_BLUE, mb: 2 }}>
                                6. Ihre Rechte
                            </Typography>
                            <Typography sx={{ mb: 3 }}>
                                Da keine personenbezogenen Daten gespeichert werden, bestehen keine weiteren
                                Betroffenenrechte wie Auskunft, Berichtigung oder Löschung im Sinne der DSGVO.
                            </Typography>

                            {/* Back to Home CTA */}
                            <Box sx={{ textAlign: "center", mt: 5 }}>
                                <Button
                                    component={RouterLink}
                                    to="/"
                                    variant="contained"
                                    size="large"
                                    sx={{ bgcolor: BRAND_GREEN, ":hover": { bgcolor: "#00B84A" } }}
                                >
                                    Zur Startseite
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            </Box>

            {/* FOOTER */}
            <Footer />
        </Box>
    );
};

export default Datenschutz;
